function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import NotificationTypeBase from "discourse/lib/notification-types/base";
import { formatUsername } from "discourse/lib/utilities";
import I18n from "discourse-i18n";
var _Class_brand = /*#__PURE__*/new WeakSet();
export default class extends NotificationTypeBase {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _Class_brand);
  }
  get label() {
    if (this.count === 2) {
      return I18n.t("notifications.liked_by_2_users", {
        username: this.username,
        username2: _classPrivateGetter(_Class_brand, this, _get_username)
      });
    } else if (this.count > 2) {
      return I18n.t("notifications.liked_by_multiple_users", {
        username: this.username,
        count: this.count - 1
      });
    } else {
      return super.label;
    }
  }
  get labelClasses() {
    if (this.count === 2) {
      return ["double-user"];
    } else if (this.count > 2) {
      return ["multi-user"];
    }
  }
  get count() {
    return this.notification.data.count;
  }
}
function _get_username(_this) {
  return formatUsername(_this.notification.data.username2);
}